import {getStorageItem, setStorageItem} from '../utils/global';

export class FavoriteItemsFilter {
    /**
     * 絞り込み（お気に入り）
     *
     * @constructor
     * @param {HTMLElement} root - ルートとなる要素
     * @param {Object} options - 設定の変更をする際のオブジェクト
     */
    constructor(root, options) {
        const config = {
            defaultCheckElementValue: 'product',
            className: {
                ctrl: 'js-favorite-filter__ctrl',
                content: 'js-favorite-filter__content',
                noticeText: 'c-text-notice',
                removeFavoriteButton: 'c-button-removeFavorite'
            },
            particularTypeHideSelector: {
                works: 'option[value="releaseDate"],option[value="releaseDateOld"]',
                artists: 'option[value="releaseDate"],option[value="releaseDateOld"]'
            }
        };

        // ルートとなる要素が無い場合は何もしない
        if (!root) {
            return;
        }

        this.config = Object.assign(config, options);
        this.root = root;
        this.ctrls = Array.from(root.querySelectorAll(`.${this.config.className.ctrl}`));
        this.content = root.querySelector(`.${this.config.className.content}`);
        [this.defaultCheckElement] = this.ctrls.filter((ctrl) => ctrl.value === this.config.defaultCheckElementValue);
        this.filterTargets = Array.from(this.content.children);
        this.removeFavoriteButton = null;
        this.noticeText = document.createElement('p');
        this.filterTypes = this.getFilterTypes();
        this.dividedElements = this.divided();
        this.currentSelectElementText = this.defaultCheckElement.parentNode.textContent;
        this.currentSelectValue = this.config.defaultCheckElementValue;
        this.currentElements = this.dividedElements[this.currentSelectValue];
        this.particularTypeHideElements = this.getParticularTypeHideElements();
        this.isAllTargetHidden = false;

        this.init();
        this.addEvent();
    }

    /**
     * init - 初期化
     * @return {Void}
     */
    init() {
        // まとめて削除ボタンを実装
        this.content.parentNode.insertAdjacentHTML('beforeend', `<div class="p-button p-button--distantly p-button--center"><button type="button" class="${this.config.className.removeFavoriteButton}" data-remove-type="${this.currentSelectValue}">お気に入りをまとめて削除</button></div>`);

        this.noticeText.classList.add(this.config.className.noticeText);
        this.removeFavoriteButton = this.content.parentNode.querySelector(`.${this.config.className.removeFavoriteButton}`);

        // 初期実行
        this.defaultCheckElement.checked = true;
        this.filter(this.currentSelectValue);
    }

    /**
     * getFilterTypes -絞り込む種類（コントロールボタンのvalue）を取得
     * @return {Array}
     */
    getFilterTypes() {
        const types = [];

        for (const ctrl of this.ctrls) {
            types.push(ctrl.value);
        }

        return types;
    }

    /**
     * getParticularTypeHideElements - 特定の種類で絞り込みが行われた場合、非表示にする要素を取得
     * @return {Object} {type: NodeList}
     */
    getParticularTypeHideElements() {
        const particularTypeKeys = Object.keys(this.config.particularTypeHideSelector);
        const elements = {};

        // 指定されていれば要素を取得・格納
        if (particularTypeKeys.length) {
            for (const key of particularTypeKeys) {
                elements[key] = document.querySelectorAll(this.config.particularTypeHideSelector[key]);
            }
        }

        return elements;
    }

    /**
     * divided - 要素をfilterTypeの種類ごとに分割して取得
     * @return {Objerct}
     */
    divided() {
        const elementData = {};

        for (const type of this.filterTypes) {
            const hasMatchTypeElements = this.filterTargets.filter((target) => target.dataset.filterType === type);

            elementData[type] = hasMatchTypeElements.length > 0 ? hasMatchTypeElements : [];
        }

        return elementData;
    }

    /**
     * addEvent - イベントバインド
     */
    addEvent() {
        /**
         * changeSortSelect - 「商品」タブの選択状態に変化があった時の処理
         * @param {Boolean} isSelectProductTab - 「商品」タブが選択状態にあるか
         */
        const changeSortSelect = (isSelectProductTab) => {
            /**
             * wrap - 任意の要素をspan要素で包む
             * @param {HTMLElement} elem - 任意の要素
             */
            const wrap = (elem) => {
                const wrapper = document.createElement('span');

                wrapper.classList.add('u-none');
                elem.parentNode.insertBefore(wrapper, elem);
                wrapper.appendChild(elem);
            };
            /**
             * unwrap - 任意の要素から子要素を取り出す。
             * @param {HTMLElement} elem - 任意の要素
             */
            const unwrap = (elem) => {
                elem.parentNode.insertBefore(elem.firstChild, elem);
                elem.parentNode.removeChild(elem);
            };
            const sortCtrl = this.root.querySelector('.js-sort__ctrl');

            // 「商品タブが」押された時
            if (isSelectProductTab && sortCtrl.querySelectorAll('span').length > 0) {
                sortCtrl.querySelectorAll('span').forEach(unwrap);
            // 「作品」「声優アーティスト」タブが選択された時
            } else if (!isSelectProductTab && sortCtrl.querySelectorAll('span').length === 0) {
                sortCtrl.querySelectorAll('.js-distribute-item').forEach(wrap);
            }
        };
        /**
         * generateChangeEvent - changeイベントの生成と実行
         * @param {Boolean} elem - changeイベントを発生させる任意の要素
         */
        const generateChangeEvent = (elem) => {
            const evt = new CustomEvent('change');

            elem.dispatchEvent(evt);
        };

        for (const ctrl of this.ctrls) {
            ctrl.addEventListener('change', (e) => {
                const targetValue = e.target.value;

                changeSortSelect(targetValue === 'product');
                generateChangeEvent(this.root.querySelector('.js-sort__ctrl'));

                // 選択されている要素のテキストを更新・削除ボタンの[data-remove-type]を更新
                this.currentSelectElementText = e.target.parentNode.textContent;
                this.removeFavoriteButton.dataset.removeType = targetValue;

                // 絞り込みを実行
                this.particularTypeHide(targetValue);
                this.filter(targetValue);
            });
        }

        this.removeFavoriteButton.addEventListener('click', () => {
            const removeFavoriteType = this.removeFavoriteButton.dataset.removeType;

            // [data-remove-type]が指定されていない場合何もしない
            if (!removeFavoriteType) {
                return;
            }

            // eslint-disable-next-line no-alert
            if (window.confirm(`お気に入りの${this.currentSelectElementText}をまとめて削除します。よろしいですか？`)) {
                // confirmダイアログの「OK」がクリックされた場合、削除を実行
                this.removeFavoriteData(removeFavoriteType);
            }
        });
    }

    /**
     * filter - 絞り込みを実行
     * @param  {String} value 表示する[data-remove-type]の値
     * @return {Void}
     */
    filter(value) {
        let isAllTargetHidden = true;

        this.currentSelectValue = value;
        this.currentElements = this.dividedElements[this.currentSelectValue];
        // this.content.classList[value === 'product' ? 'remove' : 'add']('p-layout-column__inner--narrow2column');

        for (const target of this.filterTargets) {
            const isHidden = [].indexOf.call(this.currentElements, target) === -1;

            // 表示される要素（isHidden === false）が1つでもある場合
            if (isAllTargetHidden && !isHidden) {
                isAllTargetHidden = false;
            }

            target.hidden = isHidden;
        }

        this.content.hidden = isAllTargetHidden;

        // 表示 ⇒ 全て非表示 に切り替わった場合、テキストを表示
        if (isAllTargetHidden) {
            this.removeFavoriteButton.parentNode.hidden = true;
            this.noticeText.textContent = `お気に入りに登録されている${this.currentSelectElementText}はありません`;
            this.content.parentNode.insertBefore(this.noticeText, this.content.nextSibling);

        // 全て非表示 ⇒ 表示 に切り替わった時、テキストを削除
        } else if (this.isAllTargetHidden) {
            this.removeFavoriteButton.parentNode.hidden = false;
            this.content.parentNode.removeChild(this.noticeText);
        }

        // フラグを更新
        this.isAllTargetHidden = isAllTargetHidden;
    }

    /**
     * particularTypeHide - 特定の種類で絞り込みが行われた場合、指定の要素の表示・非表示を切り替える
     * @param  {String} value 絞り込みが実行される前に表示されている[data-remove-type]の値
     * @return {Void}
     */
    particularTypeHide(value) {
        const particularTypeHideElementsKeys = Object.keys(this.particularTypeHideElements);

        // 現在表示されている[data-remove-type]で絞り込みが行われた場合に非表示する要素を表示する
        if (particularTypeHideElementsKeys.includes(this.currentSelectValue)) {
            for (const element of this.particularTypeHideElements[this.currentSelectValue]) {
                element.hidden = false;
            }
        }

        // 絞り込みが実行される前に表示されていた[data-remove-type]で絞り込みが行われた場合に表示する要素を非表示にする
        if (particularTypeHideElementsKeys.includes(value)) {
            for (const element of this.particularTypeHideElements[value]) {
                element.hidden = true;
            }
        }
    }

    /**
     * removeFavoriteData - ローカルストレージのお気に入りに追加されているデータを削除する
     * @param  {String} type 削除するお気に入りの種類
     * @return {Void}
     */
    removeFavoriteData(type) {
        const favoriteItems = JSON.parse(getStorageItem('favorite')) || {};
        const removeTargetItems = this.dividedElements[type];

        // 削除する対象が見つからない場合は何もしない
        if (!favoriteItems.hasOwnProperty(type) || !removeTargetItems.length) {
            return;
        }

        // 表示されている要素をすべて削除
        for (const item of removeTargetItems) {
            this.content.removeChild(item);
        }

        // 削除ボタンを削除、変数から要素をを削除
        this.removeFavoriteButton.parentNode.hidden = true;
        this.dividedElements[type] = [];
        this.filter(this.currentSelectValue);

        // ローカルストレージを更新
        favoriteItems[type] = [];
        setStorageItem('favorite', JSON.stringify(favoriteItems));
    }
}

/**
 * デフォルト実行処理
 * @return {Void}
 */
export default () => {
    // 絞り込み機能
    document.querySelectorAll('.js-favorite-filter').forEach((element) => new FavoriteItemsFilter(element));
};
